export default "__VITE_ASSET__IK_GzAY2__"